import {
  isControlledBackendError,
  isNetworkError,
  isConcurrentUpdateError,
  isUnauthorizedBySennder,
  isServerError,
  isServerErrorGeneric,
  applyCustomErrorConfig
} from '@/custom-errors'
import { navigateTo } from '@/router'
import { removeAuthCookie } from '@/services/auth'
import parseErrorMessage from '@/parse-error-message'
import { AlertModal } from 'plankton'

import { AxiosError } from 'axios'

/** Handles global uncaught errors: displays network errors and failed API requests to user & throws the rest to appear in Sentry */
export default function handleGlobalError(
  error: AxiosError,
  alertModal: ReturnType<typeof AlertModal>
) {
  if (isNetworkError(error)) {
    navigateTo('/will-be-back')
    return
  } else if (isControlledBackendError(error)) {
    return alertModal.showErrorMessage(
      'Whoops!',
      parseErrorMessage(error.message),
      applyCustomErrorConfig
    )
  } else if (isConcurrentUpdateError(error)) {
    const errorMessage = `This order has been edited by somebody else since you
    loaded the page. You cannot save unless you refresh the page.
    When you refresh, you will lose your changes since your last save.`
    return alertModal.showErrorMessage(
      'Concurrent update error',
      errorMessage,
      applyCustomErrorConfig
    )
  }
  if (isUnauthorizedBySennder(error)) {
    // We just logout when the unauthorized message comes from sennder's backend
    // (so we avoid logouts third-party 401's)
    removeAuthCookie()
    navigateTo('/login')
    return
  }
  if (isServerError(error)) {
    return
  }

  if (isServerErrorGeneric(error)) {
    return alertModal.showErrorMessage(
      this.$t('serverError.title'),
      this.$t('serverError.somethingWentWrong'),
      applyCustomErrorConfig
    )
  }
  throw error
}
